class ProductStickyNav extends HTMLElement {
  constructor() {
    super();
    const productInfo = document.querySelector("product-info");
    this.scrollThreshold = productInfo
      ? productInfo.getBoundingClientRect().height
      : 400;
    this.button = this.querySelector(".product-sticky-nav-cta");
    this.faqLink = this.querySelector("[data-faq]");
    this.detailsLink = this.querySelector("[data-detail]");
    this.reviewsLink = this.querySelector("[data-review]");
    this.navLinks = [this.detailsLink, this.faqLink, this.reviewsLink].filter(
      Boolean
    );
  }

  getFaqTarget() {
    const sel = this.dataset.faqTarget || ".section-bundle-faq";
    try {
      return document.querySelector(sel);
    } catch {
      return null;
    }
  }

  getReviewTarget() {
    const sel = this.dataset.reviewTarget || ".jdgm-carousel-wrapper";
    if (!sel) return null;
    try {
      return document.querySelector(sel);
    } catch {
      return null;
    }
  }

  getDetailsTarget() {
    const productInfo = document.querySelector("product-info");
    if (productInfo) return productInfo;
    return document.querySelector("#MainContent > *:nth-child(2)");
  }

  getSpyScrollY() {
    const y = window.scrollY || document.documentElement.scrollTop;
    const navOffset =
      this.classList.contains("active") ? this.offsetHeight : 0;
    return y + navOffset + 12;
  }

  setActiveLink(active) {
    for (const link of this.navLinks) {
      link.classList.toggle("is-active", link === active);
    }
  }

  updateActiveFromScroll() {
    const faqEl = this.getFaqTarget();
    const reviewEl = this.getReviewTarget();
    const line = this.getSpyScrollY();

    const topOf = (el) => {
      if (!el) return Infinity;
      const r = el.getBoundingClientRect();
      return r.top + (window.scrollY || document.documentElement.scrollTop);
    };

    const faqTop = topOf(faqEl);
    const reviewTop = topOf(reviewEl);

    if (!faqEl && reviewEl) {
      this.setActiveLink(
        line < reviewTop ? this.detailsLink : this.reviewsLink
      );
      return;
    }

    if (faqEl && line < faqTop) {
      this.setActiveLink(this.detailsLink);
      return;
    }
    if (faqEl && (!reviewEl || line < reviewTop)) {
      this.setActiveLink(this.faqLink);
      return;
    }
    if (reviewEl) {
      this.setActiveLink(this.reviewsLink);
      return;
    }
    if (faqEl) {
      this.setActiveLink(this.faqLink);
      return;
    }
    this.setActiveLink(this.detailsLink);
  }

  connectedCallback() {
    const onScroll = () => {
      const currentScroll =
        window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > this.scrollThreshold) {
        this.classList.add("active");
        document
          .querySelectorAll(".shopify-section-group-header-group")
          .forEach((el) => {
            el.classList.add("hidden");
          });
      } else {
        document
          .querySelectorAll(".shopify-section-group-header-group")
          .forEach((el) => {
            el.classList.remove("hidden");
          });
        this.classList.remove("active");
      }

      this.updateActiveFromScroll();
    };

    const throttled = this.throttle(onScroll, 80);
    window.addEventListener("scroll", throttled, { passive: true });
    window.addEventListener("resize", throttled);
    this._scrollHandler = throttled;

    onScroll();

    if (this.faqLink) {
      this.faqLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getFaqTarget();
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    }
    if (this.reviewsLink) {
      this.reviewsLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getReviewTarget();
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    }
    if (this.detailsLink) {
      this.detailsLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getDetailsTarget();
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    }
  }

  disconnectedCallback() {
    if (this._scrollHandler) {
      window.removeEventListener("scroll", this._scrollHandler);
      window.removeEventListener("resize", this._scrollHandler);
    }
  }

  throttle(func, limit = 100) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}
if (!customElements.get("product-sticky-nav")) {
  customElements.define("product-sticky-nav", ProductStickyNav);
}
